class TypeFromLockCer {
    static TO_CHUC = 1;
    static CA_NHAN = 2;
    static CA_NHAN_THUOC_TO_CHUC = 3;
  }
  
  export default TypeFromLockCer;
  